import React, { useRef } from 'react';

import Spinwheel from '../../common/Spinwheel';
import JoditEditor from 'jodit-react';
import { values } from 'lodash';

const AddOrUpdateSuport = ({ isOpen, onClose, formik, loading , activeType }) => {
  console.log("activeeeeeeeeeee",activeType)
  const editor = useRef(null);
  const getDropdownOptions = () => {
    switch (activeType) {
      case 'ride':
        return [
          { label: "Rider", value: "rider" },
          { label: "Driver", value: "driver" }
        ];
      case 'hire':
        return [
          { label: "Guest", value: "guest" },
          { label: "Host", value: "host" }
        ];
        case 'food':
        return [
          { label: "Customer", value: "customer" },
          { label: "Merchant", value: "merchant" }
        ];
        case 'package':
        return [
          { label: "Customer", value: "customer" },
          { label: "Delivery", value: "delivery" }
        ];
        case 'bus':
        return [
          { label: "Customer", value: "customer" },
          { label: "Operator", value: "operator" }
        ];
        case 'airport':
        return [
          { label: "Rider", value: "rider" },
          { label: "Driver", value: "driver" }
        ];
        case 'insurance':
        return [
          { label: "Rider", value: "rider" },
          { label: "Driver", value: "driver" }
        ];
        case "family":
          if(formik?.values?.userType !== "family") formik.setFieldValue("userType", "family");
        return [
          { label: "Family", value: "family" },
        ];
      default:
        return [
          { label: "Customer", value: "customer" },
          { label: "Service Provider", value: "provider" }
        ];
    }
  };

  const dropdownOptions = getDropdownOptions();

  return (
    <div className={`modal fade ${isOpen ? 'show' : ''}`} id="blogAddModal" tabIndex="-1" aria-labelledby="blogAddModalLabel" aria-hidden={!isOpen} style={{ display: isOpen ? 'block' : 'none' }} role={isOpen ? "dialog" : undefined}>
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            
            <h5 className="modal-title" id="blogAddModalLabel">{formik?.values?.id ? "Update" : "Add"} Question</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={formik?.handleSubmit}>
              <div className="mb-3 w-100">
                <label htmlFor="userType" className="form-label">For Which</label>
                <select
                  className="form-control w-100"
                  id="userType"
                  name="userType"
                  value={formik?.values?.userType}
                  onChange={formik?.handleChange}
                  onBlur={formik?.handleBlur}
                >
                  <option value="">Select</option>
                  {dropdownOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
                {formik?.touched?.userType && formik?.errors?.userType ? (
                  <div className='req-error'>{formik?.errors?.userType}</div>
                ) : null}
              </div>

              <div className="mb-3">
                <label htmlFor="question" className="form-label">Question</label>
                <input type="text" className="form-control" id="question" name="question" placeholder='Enter' value={formik?.values?.question} onChange={formik?.handleChange} onBlur={formik?.handleBlur} />
                {formik?.touched?.question && formik?.errors?.question ? (<div className='req-error'>{formik?.errors?.question}</div>) : null}
              </div>
              
              {/* <div className="mb-3"> */}
                {/* <label htmlFor="answer" className="form-label">Answer</label> */}
                {/* <textarea className='form-control' name="answer" id="answer" placeholder='Enter' value={formik?.values?.answer} onChange={formik?.handleChange} onBlur={formik?.handleBlur} ></textarea> */}
                <div className="mb-3">
                <label htmlFor="answer" className="form-label">Answer</label>
                <JoditEditor
                  ref={editor}
                  value={formik?.values?.answer}
                  // config={config}
                  onBlur={(e) => {
                    formik.setFieldTouched("answer", true)
                    e === "<p><br></p>" ? formik.setFieldValue("answer", "") : formik.setFieldValue("answer", e);
                  }}
                  onChange={(newContent) => {}}
                />
               {formik?.touched?.answer && formik?.errors?.answer ? (<div className='req-error'>{formik?.errors?.answer}</div>) : null}
              </div>
               
              {/* </div> */}
              <button type="submit" className="btn btn-primary" disabled={loading}>  {loading ? <Spinwheel sizeClass={"spin-small"} /> : "Submit"}</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddOrUpdateSuport;